module.exports = __webpack_public_path__ + "static/media/getting-support@3x.5e657876.png";